import { fetchProviderByIds, SEPARATOR } from "../misc";
import _ from "lodash";
import { queryKpisOpenData } from "../misc/kpiOpenApi";
import { KpiReport } from "../../Components/processors";

export const getProviderCountAllKpisExist = async (kpis?: string[][], locationAdminIds?: string[]): Promise<number> => {
    const allow =
        !kpis ||
        !kpis.filter(d => d != null).length ||
        !locationAdminIds ||
        !locationAdminIds.filter(d => d != null && d.toString().trim() !== "")
            ? false
            : true;

    if (!allow) return 0;
    const providers = await fetchProviderByIds(locationAdminIds);

    // const valid = locationAdminIds.filter(d => d != null && d.toString().trim() !== "");
    // query providers by locationAdminIds
    // const query = _.join(valid, " OR ");
    // const solrQuery = _.join(
    //     [
    //         "q=*:*",
    //         "rows=1000",
    //         `fq=pure_strings_admin_id:(${query})`,
    //         //"fl=pure_strings_sname,pure_strings_admin_id,its_tid"
    //         `fl=${PROVIDER_FIELDS}`
    //     ],
    //     QUERY_URL_AND
    // );

    // const providers = await queryWaterProviderWithDocs(solrQuery);
    // , {
    //     cache: valid?.length === 1 ? "force-cache" : "no-cache"
    //     // cache: "force-cache"
    // });

    const results = await queryKpisOpenData(
        {
            providerNames: providers?.map(d => d.kapiName),
            kpis
        },
        providers,
        {
            cache: "force-cache"
        }
    );

    const keyFn = ({ kpiCode, schemeType }: Partial<KpiReport>) =>
        _.join(
            [kpiCode, schemeType].filter(d => d != null && d.trim() !== ""),
            SEPARATOR
        );

    const adminToResults = _.groupBy(results, d => d?.provider?.adminId);

    const providersFound = providers?.map(d => {
        if (!adminToResults?.[d.adminId]) return false;

        const kpiCodeSchemeToResults = _.groupBy(adminToResults?.[d.adminId], keyFn);

        const latestYear = _.maxBy(adminToResults?.[d.adminId], d => d.year ?? 0)?.year;

        const kpiFound = kpis?.map(kpi => {
            const kpiCode = kpi?.[0];
            const schemeType = kpi?.[1];

            const kpiResults =
                kpiCodeSchemeToResults?.[
                    keyFn({
                        kpiCode,
                        schemeType
                    })
                ];

            return latestYear != null && kpiResults?.find(d => d?.year === latestYear) != null;
        });

        return kpiFound?.filter(d => d === true)?.length === kpis?.length;
    });

    return providersFound?.filter(d => d === true).length ?? 0;
};
